import { render } from "./AiViewTerm.vue?vue&type=template&id=875de88a"
import script from "./AiViewTerm.vue?vue&type=script&lang=js"
export * from "./AiViewTerm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__